import {ChangeDetectionStrategy, Component, computed, inject, Input, Signal} from '@angular/core';
import {CustomerService} from "../../../shared/services/customer.service";
import {QRCodeComponent} from "angularx-qrcode";

@Component({
    selector: 'app-bar-footer',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
      QRCodeComponent
    ],
    styleUrl: './bar-footer.component.scss',
    template: `
  @if (showAppDownload && downloadUrl()) {
    <div class="app-store-buttons">
      <div class="app-download-qr">
        <qrcode
          [qrdata]="downloadUrl()!"
          [width]="110"
          [margin]="1"
          [errorCorrectionLevel]="'M'"
          [ariaLabel]="'APPDOWNLOAD'"
          [alt]="'APPDOWNLOAD'"
        />
      </div>
    </div>
  }
  `
})
export class BarFooterComponent {
  private customerService: CustomerService = inject(CustomerService);

  @Input() public showAppDownload: boolean = true;

  public downloadUrl: Signal<string | null> = computed(() => {
    const customerKey = this.customerService.customerKey();
    if (!customerKey) return null;
    return `https://dl.humanstars.app/downloads/${customerKey}`;
  });
}
